import { CreateEditJobNavEnum } from 'containers/jobs/constant';
import { CreateJobContextType } from 'containers/jobs/types';
import React, { FC, useContext } from 'react';
import JobNotesSection from './JobNotesSection';
import JobAttachmentsSection from './JobAttachementsSection';

interface NotesAndAttachmentsSectionProps {
  className?: string;
  context: React.Context<CreateJobContextType>;
}

const NotesAndAttachmentsSection: FC<NotesAndAttachmentsSectionProps> = ({ context }) => {
  const { selectedJobTab, setSelectedJobTab } = useContext<CreateJobContextType>(context);

  const isTabSelected = selectedJobTab === CreateEditJobNavEnum.NOTES_ATTACHMENTS;

  const updateSelectedJobTab = () => {
    setSelectedJobTab(CreateEditJobNavEnum.NOTES_ATTACHMENTS);
  };

  return (
    <div>
      <div className="mb-2 text-xl font-bold text-heading">Notes & Attachments</div>
      <div
        className={`relative rounded-md border py-6 px-8 ${isTabSelected ? 'border-primaryBtn' : 'border-borderGray'}`}>
        <JobNotesSection handleOnFocus={updateSelectedJobTab} />
        <JobAttachmentsSection handleOnFocus={updateSelectedJobTab} />
      </div>
    </div>
  );
};

export default NotesAndAttachmentsSection;
